<template>
  <div>
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";

export default {
  name: "HeaderPage",

  components: {
    Header,
  },
};
</script>